/**
 * Wally PDP Engagement
 * Tracks product detail page views and add-to-cart events,
 * with collection referrer context from query params.
 *
 * Reads ?ref=collection-handle&pos=N from the URL (set by collection engagement script).
 *
 * Required data attribute on product page:
 *   data-product-id="123456789"  (Shopify numeric product ID)
 *
 * Config (set before this script loads):
 *   window.__wEp = 'https://endpoint/events';
 */

(function () {
  'use strict';

  var ENDPOINT = window.__wEp;
  if (!ENDPOINT) return;

  // Get product ID from the page
  var productEl = document.querySelector('[data-product-id]');
  if (!productEl) return;
  var productId = productEl.getAttribute('data-product-id');
  if (!productId) return;

  // Get collection referrer context from query params
  var params = new URLSearchParams(window.location.search);
  var refCollection = params.get('ref');
  var refPosition = params.get('pos');

  // Session ID (same as collection script)
  var sessionId = sessionStorage.getItem('wally_sid');
  if (!sessionId) {
    sessionId = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2);
    sessionStorage.setItem('wally_sid', sessionId);
  }

  var eventQueue = [];

  function queueEvent(type) {
    eventQueue.push({
      type: type,
      product_id: productId,
      collection: refCollection || 'direct',
      position: refPosition ? parseInt(refPosition, 10) : null,
      timestamp: Math.floor(Date.now() / 1000),
    });
  }

  function flush() {
    if (eventQueue.length === 0) return;

    var payload = JSON.stringify({
      events: eventQueue.splice(0),
      session_id: sessionId,
      page_url: location.pathname,
    });

    // sendBeacon with plain string avoids CORS preflight, critical for
    // ATC events that flush during page transitions.
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, payload);
    } else {
      fetch(ENDPOINT, {
        method: 'POST',
        body: payload,
        headers: { 'Content-Type': 'text/plain' },
        keepalive: true,
      }).catch(function () {});
    }
  }

  // --- PDP view event ---

  queueEvent('pdp_view');

  // Fire GA4 view_item with collection context
  if (typeof gtag === 'function' && refCollection) {
    gtag('event', 'view_item', {
      item_list_name: refCollection,
      item_list_id: refCollection,
      items: [{
        item_id: productId,
        index: refPosition ? parseInt(refPosition, 10) : undefined,
        item_list_name: refCollection,
      }],
    });
  }

  // --- Add to cart tracking ---

  var atcFired = false;
  function trackAtc() {
    if (atcFired) return;
    atcFired = true;
    queueEvent('atc');
    flush();
    // Reset after a short delay so repeat ATCs on same page are tracked
    setTimeout(function () { atcFired = false; }, 2000);
  }

  // Use capture phase to fire before Horizon's product-form-component
  // calls event.preventDefault() in its on:submit handler.
  var addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  for (var i = 0; i < addToCartForms.length; i++) {
    addToCartForms[i].addEventListener('submit', trackAtc, true);
  }

  // Intercept fetch-based add to cart (Horizon uses fetch to /cart/add.js)
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var url = arguments[0];
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        trackAtc();
      }
      return originalFetch.apply(this, arguments);
    };
  }

  // Backup: listen for Horizon's cart update event (fires after successful ATC)
  document.addEventListener('cart:update', trackAtc);

  // --- Clean up referrer params from URL (cosmetic) ---

  if (refCollection && window.history && window.history.replaceState) {
    params.delete('ref');
    params.delete('pos');
    var cleanUrl = window.location.pathname;
    var remaining = params.toString();
    if (remaining) cleanUrl += '?' + remaining;
    window.history.replaceState(null, '', cleanUrl);
  }

  // --- Flush on page hide ---

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);

  // Flush after short delay in case user bounces quickly
  setTimeout(flush, 5000);
})();
